/* eslint-disable react/jsx-props-no-spreading */
import { FC } from 'react';
import classNames from 'classnames';

import { ToastViewport as UiKitToastViewport } from '@zvuk-b2b/ui-kit';
import type { ToastViewportProps as UiKitToastViewportProps } from '@zvuk-b2b/ui-kit';

import styles from './ToastViewport.module.scss';

export type ToastViewportProps = UiKitToastViewportProps;

const ToastViewport: FC<ToastViewportProps> = ({ position = 'bottomCenter', toastClassName, ...rest }) => (
  <UiKitToastViewport
    position={position}
    toastClassName={classNames(styles.legacyToast, toastClassName)}
    {...rest}
  />
);

export default ToastViewport;
